"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addResponseErrorInterceptor = exports.addResponseSuccessInterceptor = void 0;
const msalInstance_1 = require("@/commons/msalInstance");
const authentication_1 = require("@/constants/authentication");
const localStorage_1 = require("@/utilities/localStorage");
const api_1 = require("./api");
const authentication_2 = require("./authentication");
function addResponseSuccessInterceptor() {
    return (response) => {
        return response;
    };
}
exports.addResponseSuccessInterceptor = addResponseSuccessInterceptor;
function addResponseErrorInterceptor() {
    return async (error) => {
        const originalRequest = error.settings;
        const isUserUnauthorized = (error?.response?.status === 401 || error?.response?.status === 403) &&
            !originalRequest?._retry;
        if (isUserUnauthorized) {
            const user = (0, localStorage_1.getItemFromLocalStorage)("AuthContext", null);
            const currentUserAccount = msalInstance_1.msalInstance.getAccountByHomeId(user.homeAccountId);
            if (currentUserAccount) {
                const response = await (0, authentication_2.acquireToken)(currentUserAccount);
                if (response) {
                    originalRequest._retry = true;
                    api_1.axiosInstance.defaults.headers.common.Authorization = `Bearer ${response.accessToken}`;
                    const newInstance = await (0, api_1.axiosInstance)(originalRequest);
                    return newInstance;
                }
            }
            msalInstance_1.msalInstance.loginRedirect(authentication_1.IFF_LOGIN_REQUEST);
        }
        return Promise.reject(error);
    };
}
exports.addResponseErrorInterceptor = addResponseErrorInterceptor;
